import React from 'react'
import clsx from 'clsx'

interface BadgeProps {
  children: React.ReactNode
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info'
  className?: string
}

const variantStyles: Record<string, { bg: string; color: string }> = {
  default: { bg: 'var(--bg-tertiary)', color: 'var(--text-secondary)' },
  success: { bg: 'var(--success-light)', color: 'var(--success)' },
  warning: { bg: 'rgba(255, 149, 0, 0.1)', color: 'var(--warning)' },
  danger: { bg: 'var(--danger-light)', color: 'var(--danger)' },
  info: { bg: 'rgba(0, 122, 255, 0.1)', color: 'var(--info)' },
}

export const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', className }) => {
  const style = variantStyles[variant]

  return (
    <span
      className={clsx('inline-flex items-center px-2 py-0.5 rounded-md text-[12px] font-medium', className)}
      style={{ backgroundColor: style.bg, color: style.color }}
    >
      {children}
    </span>
  )
}
